import Vue from 'vue';
import objectToFormData from 'object-to-formdata';

export default {
  getImageAPIUrl() {
    const imgapiurl = process.env.VUE_APP_imgApiUrl || process.env.VUE_APP_apiUrl
    return imgapiurl || `${window.location.origin}/api`; 
  },
  getAPIUrlFromPath(path) {
    let apiurl = process.env.VUE_APP_apiUrl
      ? process.env.VUE_APP_apiUrl
      : `${window.location.origin}/api`;

    if (
      (path.startsWith('/note') && !path.startsWith('/notecategory')) ||
      path.startsWith('/report') ||
      path.startsWith('/download')
    ) {
      apiurl = this.getImageAPIUrl()
    }
    return apiurl
  },
  get(path, options = {}) {
    return Vue.http.get(this.getAPIUrlFromPath(path) + path, options)
      .then(
        response => response,
        response => response,
      )
      .catch(
        err => err,
      );
  },
  post(path, payload, options = {}) {
    return Vue.http.post(this.getAPIUrlFromPath(path) + path, payload, options).then(
      response => response,
      reject => reject,
    );

    // const requestOptions = {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   headers: { 'x-clinic': cliniccode },
    //   body: JSON.stringify({email: username, password}),
    // };

    // return fetch(`${process.env.VUE_APP_apiUrl}/auth/login`, requestOptions);
  },
  patch(path, payload, options = {}) {
    return Vue.http.patch(this.getAPIUrlFromPath(path) + path, payload, options).then(
      response => response,
      response => response,
    );
  },
  put(path, payload, options = {}) {
    return Vue.http.put(this.getAPIUrlFromPath(path) + path, payload, options);
  },
  delete(path, payload = undefined) {
    return Vue.http.delete(this.getAPIUrlFromPath(path) + path, payload ? { body: payload } : undefined).then(
      response => response,
      response => response,
    );
  },
  upload(path, payload, onProgress) {
    return Vue.http.post(this.getImageAPIUrl() + path, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      progress: (e) => {
        this.progress = (e.loaded / e.total) * 100;
        if (typeof onProgress === 'function') {
          onProgress(e);
        }
      },
    }).then(
      response => response,
      response => response,
    );
  },
  uploadImageApi(path, payload) {
    return Vue.http.post(this.getImageAPIUrl() + path, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then(
      response => response,
      reject => reject,
    );
  },
  multiPartPost(path, payload, fileObj = {}) {
    const formData = objectToFormData(payload, { indices: true });
    Object.entries(fileObj).forEach(([key, val]) => {
      formData.append(key, val);
    });
    return Vue.http.post(this.getImageAPIUrl() + path, formData)
      .then(
        response => response,
        reject => reject,
      );
  },
  multiPartPostForBlob(path, payload, fileObj = {}) {
    const formData = objectToFormData(payload, { indices: true });
    Object.entries(fileObj).forEach(([key, val]) => {
      formData.append(key, val);
    });
    return Vue.http.post(this.getImageAPIUrl() + path, formData, { responseType: 'blob' })
      .then(
        response => response,
        reject => reject,
      );
  },
  multiPartPut(path, payload, fileObj = {}) {
    const formData = objectToFormData(payload, { indices: true });
    Object.entries(fileObj).forEach(([key, val]) => {
      formData.append(key, val);
    });
    return Vue.http.put(this.getImageAPIUrl() + path, formData)
      .then(
        response => response,
        reject => reject,
      );
  },
  multiPartPatch(path, fileObj = {}) {
    const formData = objectToFormData({}, { indices: true });
    Object.entries(fileObj).forEach(([key, val]) => {
      formData.append(key, val);
    });
    return Vue.http.patch(this.getImageAPIUrl() + path, formData)
      .then(
        response => response,
        reject => reject,
      );
  },
  lotusPost(url, payload) {
    return Vue.http.post(url, payload).then(
      response => response,
      reject => reject,
    );
  },
  saveBlob(blob, fileName) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  },
};
